export { default } from "./AnimatedVideoHeader";